import { UpdatePhoneNumberRequestPayload } from "~/common/types/verificationCode";
import {
  PatientInformation,
  UpdateCurrentPatientData,
} from "~/patients/utils/types";
import { api } from "../axios";

interface UpdateUserDetailsRequestPayload {
  userId: string;
  userData: UpdateCurrentPatientData;
}

export const updatePatientData = async ({
  userData,
  userId,
}: UpdateUserDetailsRequestPayload) => {
  const res = await api.put<PatientInformation>(
    `/v1/patients/${userId}`,
    userData,
  );
  return res.data;
};

export const uploadFile = async (image: File) => {
  const formdata = new FormData();
  formdata.append("file", image);
  const res = await api.post<{ url: string }>("/v1/patients/files", formdata, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const deleteFile = async () => {
  const res = await api.delete<{ url: string }>("/v1/patients/files");
  return res.data;
};

export const updatePhoneNumber = async ({
  user_id,
  verification_token,
  phone_number,
}: UpdatePhoneNumberRequestPayload) => {
  const { data } = await api.put<string>(`/v1/patients/${user_id}/phone`, {
    verification_token,
    phone_number,
  });

  return data;
};
